import { render } from "./project-view-model.vue?vue&type=template&id=c519d3cc"
import script from "./project-view-model.vue?vue&type=script&lang=js"
export * from "./project-view-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__